import _http_v1 from "../../../http_requests/_http_v1";

/**
 * 
 * @param {Object} group objeto representativo de um grupo. Como vem serializado do servidor
 * @param {Object} options  lista de options
 * options {
 *  container; required
 *  group_type_id:default 1 
 *  groupable_list: default []
 *  constraints: default {}
 * }
 */

export default function Form(group, options){
    let container = options.container
    let url = "groups/"
    let method = 'POST'
    let group_type_id = options.group_type_id
    let groupable_list = options.groupable_list || []
    let constraints = options.constraints || {}
    let current_select_func = options.current_select_func
    let element,select_container, select_element,input_container, input_element,buttons_container,submit_button,current_selected_button;

    let ERRORS = {

    }

    let labels = {
        name: 'Nome do grupo',
        groupable: 'Integrantes do grupo'
    }

    initialize.call(this)

    function initialize(){
        if(group && group.id){
            url += group.id
            method = 'PUT'
        }
    }

    this.generate = () =>{
        //criando form
        element = createElement("div", "form-group-component")

        //criando input 'nome do grupo'
        generateInput()
        
        //criando lista de agrupáveis para seleção
        generateSelect()

        //criando botões de controle
        generateButtons()
        
        //adicionando os form-controls no form
        $(element).append(input_container, select_container, buttons_container)

        //adicionando form ao container do parâmetro
        $(container).html(element)

        //inicializando selectPicker
        $(select_element).selectpicker({deselectAllText:"", selectAllText: "", liveSearch:true});

        //selecionando integrantes caso preenchido no objeto 'group'
        if(group && group.group_members){
            let members_ids = group.group_members.map(x=>x.groupable.id)
            this.setMembers(members_ids)
        }

        //eventsHandler
        eventsHandler()
    }

    this.setMembers = (members_ids) =>{
        $(select_element).selectpicker('val', members_ids);
    }

    function eventsHandler(){
        $(submit_button).on('click', function(){
            let params = {
                group:{
                    name: input_element.value,
                    group_type_id: group_type_id,
                    options: {
                        constraints: constraints
                    }
                },
                group_members: $(select_element).val(),
            }
            hideAllErrors()
            let validation = validate(params)
            if(validation.status){
                _http_v1.request(url, method, params).then(data=>{
                    $(document).trigger('form-group::submit-valid', data)
                }).fail(data=>{
                    $(document).trigger('form-group::submit-error', data)
                })
            } else {
                $(document).trigger('form-group::invalid-fields', validation)
                showErrors()
            }
        })
    }

    function hideAllErrors() {
        ERRORS = {}
        $(element).find('input.validable').removeClass('is-invalid')
    }

    function showErrors(){
        $.each(ERRORS, function(field, message){
            $(element).find('input.validable[name="'+field+'"]').addClass('is-invalid')
        })
    }

    function validate(params = {}){
        let status = true
        let message = ""
        if(!params.group.name.replace(" ", "")){
            status = false
            message = 'Nome do grupo inválido'
            ERRORS['name'] = {message: message}
        } else if (params.group_members.length <= 1){
            status = false
            message = 'O grupo deve ter ao menos 2 integrantes'
            ERRORS['members'] = {message: message}
        }
        // if(params.)
        return {status:status, message:message}
    }

    function generateButtons(){
        buttons_container = createElement('div', 'buttons-group') 
        submit_button = createElement('button', 'btn btn-success')
        submit_button.type = 'button'
        submit_button.innerText = "Salvar"
        buttons_container.appendChild(submit_button)
    }    

    function generateInput(){
        //gerando container no input
        input_container = createElement('div', 'form-group')

        //gerando label
        let label = createLabel(labels.name)

        //gerando form-control input
        input_element = createElement('input', 'form-control validable')
        input_element.name = 'name'

        //preenchendo o input se informação existir
        if(group && group.name){
            input_element.value =group.name
        }
        
        //adicionando input ao container do mesmo
        $(input_container).append(label,input_element)
    }

    function generateSelect(){
        //container
        select_container = createElement('div', 'form-group')

        //label
        let label = createLabel(labels.groupable)

        //select
        select_element = createElement('select', 'form-control validable selectpicker')
        select_element.multiple = 'true'
        select_element.name = 'members'

        //button
        if(current_select_func){
            current_selected_button = createElement('span', 'badge btn-sm float-right badge-info mt-1')
            current_selected_button.role = 'button'
            current_selected_button.innerText = "Atualmente selecionados"

            $(current_selected_button).on('click', ()=>{
                current_select_func()
            })

            tippy(current_selected_button, {
                content: "Os integrantes do grupo serão os postos atualmente selecionados no mapa",
                placement: 'bottom'
            });
        }

        if(groupable_list){
            groupable_list.forEach(item=>{
                $(select_element).append("<option value='"+item.id+"'>"+item.prefix+"</option>")
            })
        }
        $(select_container).append(label,select_element,current_selected_button)
    }

    function createElement(type, klass){
        let element = document.createElement(type)
        $(element).addClass(klass)
        return element
    }

    function createLabel(text){
        let label = document.createElement('label')
        label.innerText = text
        return label
    }
}